import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react'

import { Button } from '@chakra-ui/react'
const ConfirmModal = function ({ isOpen, onClose, bodyText, title, onSuccess, confirmText = "Mark completed"}) {
  // const { isOpen, onOpen, onClose } = useDisclosure()
  return (
    <>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{title}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {bodyText}
          </ModalBody>

          <ModalFooter>
            
            <Button variant='ghost' colorScheme='blue' onClick={onClose}>Cancel</Button>
            <Button colorScheme="blue" onClick={onSuccess}>
              {confirmText}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ConfirmModal